import { render, staticRenderFns } from "./UserSelectItem.vue?vue&type=template&id=28571caa&scoped=true&"
import script from "./UserSelectItem.vue?vue&type=script&lang=js&"
export * from "./UserSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectItem.vue?vue&type=style&index=0&id=28571caa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28571caa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VImg})
